// extracted by mini-css-extract-plugin
export default {"container":"EmployeesList_container__zN3tU","pagination":"EmployeesList_pagination__CVvTM"};